import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { Button, Icon } from '@octano/global-ui';

import SectionTitle from '../../../../../../components/text/SectionTitle';
import { TranslationsKeys } from '../../../../../../locales/translations';
import { RequestedDocument } from '../../../../../../types/signDocumentationTypes';
import isIcon from '../../../../../../utils/isIcon';

interface Props {
  requestedDocuments: RequestedDocument[];
  postulationDetailId: number;
  onDownload: (doc: RequestedDocument) => void;
  onDownloadAll: () => void;
}

export default function DocumentationSection({
  requestedDocuments,
  onDownload,
  onDownloadAll,
}: Props) {
  const { t } = useTranslation(
    TranslationsKeys.HOMOLOGATION_AUTHORIZATION_DETAIL,
  );

  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-start mb-1">
        <SectionTitle text={t('documentation.title')} />
        <Button
          text={t('documentation.downloadAll')}
          outlined
          size="sm"
          onClick={onDownloadAll}
          icon="download"
        />
      </div>
      <p className="text-muted mb-3">{t('documentation.description')}</p>

      {requestedDocuments.length === 0 ? (
        <p className="text-muted text-center py-3">
          {t('documentation.noDocuments')}
        </p>
      ) : (
        <Row className="mx-n2 align-items-end">
          {requestedDocuments.map((reqDoc) => {
            const doc = reqDoc.document;
            return (
              <Col key={doc.id} xs={6} md={2} className="mb-3">
                <div className="d-flex align-items-end">
                  <span className="text-uppercase fs-14 fw-600 text-secondary">
                    {doc.name}
                  </span>
                </div>

                <div
                  className="bg-light px-2 py-2 mb-2 d-flex flex-column align-items-center justify-content-center"
                  style={{ minHeight: '120px' }}
                >
                  <Icon
                    name={isIcon(doc.icon) ? doc.icon : 'certificate'}
                    size="55px"
                    color="secondary"
                  />
                  {reqDoc.uploaded && (
                    <div className="mt-2 w-100 px-1">
                      <Button
                        icon="download"
                        onClick={() => onDownload(reqDoc)}
                        outlined
                        size="sm"
                        text={t('documentation.download')}
                        fullwidth
                      />
                    </div>
                  )}
                </div>
              </Col>
            );
          })}
        </Row>
      )}
    </div>
  );
}
